// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__FmYTn","close":"styles_close__2qM8b","scrollToTop":"styles_scrollToTop__h7eBq"};